export default {
  asset: "Assets",
  article: "Artikel",
  feature: "weitere Ausstattungsmerkmale",
};
